var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.item
    ? _c("section", { staticClass: "module dt-relative" }, [
        _c("h3", [_vm._v("相关可播资源")]),
        _vm._v(" "),
        _c(
          "ul",
          {
            class: [
              "dt-relative-wrap",
              _vm.item && _vm.item.length < 8 ? "no-more" : "",
            ],
          },
          _vm._l(_vm.item, function (i, index) {
            return _c("li", { key: index }, [
              _c(
                "a",
                {
                  attrs: {
                    href: i.url,
                    uigs: i._status
                      ? _vm.type + "_out_" + i._status + "_" + index
                      : _vm.type + "_out_list_video_" + index,
                    uigsparams: `play_type=video&play_url=${encodeURIComponent(
                      i.ourl
                    )}&play_site=${i.domain}`,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "dt-relative-item-img" },
                    [
                      _c("Image-1", { attrs: { src: i.picurl } }),
                      _vm._v(" "),
                      _c("span", { staticClass: "tag-play" }, [
                        _c("i", [
                          _vm._v(_vm._s(_vm.formatDuration(i.duration))),
                        ]),
                      ]),
                      _vm._v(" "),
                      i._status === "clips"
                        ? _c("span", { staticClass: "tag-type" }, [
                            _vm._v("速看"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "dt-relative-item-info" }, [
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.formatTitle(i.title)) },
                    }),
                  ]),
                ]
              ),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _vm.item && _vm.item.length === 8
          ? _c(
              "a",
              {
                staticClass: "dt-more rgt",
                attrs: {
                  href: _vm.moreurl,
                  uigs: _vm.type + "_out_list_video_more",
                },
              },
              [_c("span", [_vm._v("更多相关资源")])]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }